"use strict";
var Ajv = require('ajv');
var segmentSchema = require('./segmentSchema');
var ajv = Ajv({
    allErrors: true
});
var validate = ajv.compile(segmentSchema);
var validateSegment = function validateSegment(segmentJson) {
    var isValid = validate(segmentJson);
    if (isValid)
        return true;
    return ajv.errorsText(validate.errors);
};
module.exports = validateSegment;
